import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChipSymbolLineDotted = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 18,
	viewBox: "0 0 48 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 18,
			rx: 9,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10,
			y: 7,
			width: 4,
			height: 4,
			rx: 2,
			fill: "#424242"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 18,
			y: 7,
			width: 4,
			height: 4,
			rx: 2,
			fill: "#424242"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 26,
			y: 7,
			width: 4,
			height: 4,
			rx: 2,
			fill: "#424242"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 34,
			y: 7,
			width: 4,
			height: 4,
			rx: 2,
			fill: "#424242"
		})
	]
});
export default SvgChipSymbolLineDotted;
